// removed by extract-text-webpack-plugin
module.exports = {"about":"About__about___1KnDD","wrapper":"About__wrapper___21czg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/About/About.css
// module id = 952
// module chunks = 0